<div class="full-width page-content page-padding full-screen-height-page-banner" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
      <div fxLayout="row" fxLayoutGap="15px">
        <div class="subtitle-default">Showcase</div>
      </div>
    </div>

    <app-image-grid [imageFiles]="applicationImageFiles"
                    [hasMoreImagesToLoad]="hasMoreImagesToLoad"
                    [isLoading]="isLoading"
                    [allowDelete]="false"
                    [allowAdd]="false"
                    [allowDownload]="true"
                    [filePrefix]="utils.generateCodeFromString(companyName) + '_showcase_app'"
                    [heading]="'Application Images'"
    ></app-image-grid>
  </div>

  <div fxLayout="column" fxLayoutGap="20px" *ngIf="leaseImageMap.size > 0">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
      <div fxLayout="row" fxLayoutGap="15px">
        <div class="subtitle-default">Leases</div>
      </div>
    </div>

    @for (lease of leaseImageMap.values(); track lease) {
      <app-image-grid [imageFiles]="lease.files"
                      [hasMoreImagesToLoad]="lease.hasMoreImagesToLoad"
                      [isLoading]="lease.isLoading"
                      [allowDelete]="true"
                      [allowAdd]="true"
                      [allowDownload]="true"
                      [filePrefix]="utils.generateCodeFromString(companyName) + '_showcase_lease'"
                      [heading]="lease.lease.spaceNames"
                      [subHeading]="dateUtils.displayShortDate(lease.lease.leaseStartDate) + ' to ' + dateUtils.displayShortDate(lease.lease.leaseEndDate)"
                      (addImage)="addImage(lease.lease.uuid)"
                      (deleteImage)="removeDocumentFromLease($event, lease.lease.uuid)"
                      (loadMoreImages)="loadMoreLeaseImages(lease.lease.uuid)"
      ></app-image-grid>
    }
  </div>

</div>
